export const getOncoObject = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/get-oncoemr-object`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch Onco object");
    }

    const oncoObject = await response.json();
    
    return oncoObject;
  } catch (error) {
    console.error("Error fetching Onco object:", error);
    throw error;
  }
}

export const saveOncoObject = async (oncoObject) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/update-ehr-password`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
      body: JSON.stringify(oncoObject),
    });

    if (!response.ok) {
      throw new Error("Failed to save Onco object");
    }

    const result = await response.json();
    
    return result;
  } catch (error) {
    
    throw error;
  }
}